import i18n from '@/i18n';
import { NavigationGuard } from 'vue-router';
import { isUserInfoReady } from '../collections/contracts-api/user-info/user-info.helper';
import { checkAddon } from '../helpers/auth.helper';

const ADDON_GUARD = (requiredAddon: string): NavigationGuard => {
   return async (to, from, next) => {
      await isUserInfoReady();

      if (checkAddon(requiredAddon)) return next();

      notifyError({ title: i18n.global.t('generic.access-denied') });
      return next('/');
   };
};

export default ADDON_GUARD;
